(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/table-of-race-details.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/table-of-race-details.js');
"use strict";




const imageMockable = svs.content.image_v2;
const {
  getFormattedDate,
  getFormattedTime
} = svs.components.lbUtils.helpers.formatDate;
const DEFAULT_NUMBER_OF_DETAIL_LINES = 6;


const defaultProps = {
  pixData: null,
  raceData: null
};


const HighFiveLogo = () => React.createElement("svg", {
  className: "quickplay-modal-high-five-logo",
  height: "24",
  version: "1.1",
  viewBox: "0 0 207 60",
  width: "84",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, React.createElement("path", {
  d: "M16.0385 0.599951V25.4H9.23848V0.599951H0.438477V59H9.23848V34.2H16.0385V59H24.8385V0.599951H16.0385Z M29.116 0.599951V59H37.916V0.599951H29.116Z M53.1285 38.2H57.5285V50.04C57.5285 50.36 57.2885 50.6 56.9685 50.6H51.4485C51.2085 50.6 50.9685 50.36 50.9685 50.04V9.55995C50.9685 9.23995 51.2085 8.99995 51.4485 8.99995H56.8885C57.2085 8.99995 57.4485 9.23995 57.4485 9.55995V18.1999H66.2485V9.79995C66.2485 4.51995 62.0085 0.199951 56.6485 0.199951H51.7685C46.4885 0.199951 42.1685 4.51995 42.1685 9.79995V49.7999C42.1685 55.0799 46.4885 59.4 51.7685 59.4H56.6485C62.0085 59.4 66.3285 55.0799 66.3285 49.7999V29.4H53.1285V38.2Z M86.1335 0.599951V25.4H79.3335V0.599951H70.5335V59H79.3335V34.2H86.1335V59H94.9335V0.599951H86.1335Z M134.715 9.39995V0.599951H113.435V59H122.235V34.2H134.715V25.4H122.235V9.39995H134.715Z M138.988 0.599951V59H147.788V0.599951H138.988Z M171.96 0.599951L166.68 37.64H166.36L161.08 0.599951H151.24L161.64 59H171.48L181.8 0.599951H171.96Z M206.529 9.39995V0.599951H185.249V59H206.529V50.2H194.049V34.2H206.529V25.4H194.049V9.39995H206.529Z"
}));
const ParticipantInfo = _ref => {
  let {
    participants,
    participantNumber,
    hasMoreInfo,
    isReserve
  } = _ref;
  const participant = participants.find(item => item.number === participantNumber);
  if (isReserve) {
    return React.createElement(React.Fragment, {
      key: "reserve"
    }, React.createElement("div", null, React.createElement("span", {
      className: "btn-bet btn-bet-200 btn-bet-animated btn-bet-racing pix-btn-bet-racing btn-bet-selected pix-reserve pix"
    }, React.createElement("span", {
      className: "btn-bet-label"
    }, participantNumber))), Boolean(hasMoreInfo && participant) && React.createElement("div", {
      className: "reserve-horse-qp"
    }, participant.horseName));
  }
  return React.createElement("div", {
    className: "pix-selection"
  }, React.createElement("div", null, React.createElement("span", {
    className: "btn-bet btn-bet-200 btn-bet-racing pix-btn-bet-racing btn-bet-selected pix"
  }, React.createElement("span", {
    className: "btn-bet-label"
  }, participantNumber))), Boolean(hasMoreInfo && participant) && React.createElement("div", {
    className: "pix-participant-info"
  }, React.createElement("span", {
    className: "horse-info"
  }, participant.horseName), Boolean(participant.driverName) && React.createElement("div", {
    className: "driver-info"
  }, Boolean(participant.silkImageOptions) && React.createElement("div", {
    className: "driver-info-image"
  }, React.createElement(imageMockable.Image, {
    image: participant.silkImageOptions
  })), React.createElement("span", null, participant.driverName))));
};

const TableOfRaceDetails = _ref2 => {
  var _pixData$signsByEvent;
  let {
    raceData,
    pixData
  } = _ref2;
  const {
    productName,
    isHighFive,
    closeTime,
    trackName,
    raceNumber,
    participants,
    raceName
  } = raceData;
  const racingSigns = (pixData === null || pixData === void 0 || (_pixData$signsByEvent = pixData.signsByEventForOutput) === null || _pixData$signsByEvent === void 0 ? void 0 : _pixData$signsByEvent.racing) || new Array(DEFAULT_NUMBER_OF_DETAIL_LINES).fill([]);
  const date = getFormattedDate(closeTime, true, true, true);
  const time = getFormattedTime(closeTime);
  const _turnSignsIntoListItem = (currSigns, index, allSigns) => {
    const isReserve = index === allSigns.length - 1;
    return React.createElement("div", {
      className: "pix-bet-summary-list-item",
      key: "placement-".concat(index)
    }, React.createElement("div", {
      className: isReserve ? 'pix-leg-number reserve' : 'pix-leg-number'
    }, isReserve ? 'Reserv' : "".concat(index + 1, ":a")), currSigns.map(participantNumber => React.createElement(ParticipantInfo, {
      hasMoreInfo: currSigns.length === 1,
      isReserve: isReserve,
      key: participantNumber,
      participantNumber: participantNumber,
      participants: participants
    })));
  };
  const mappedRacingSigns = racingSigns.map(_turnSignsIntoListItem);
  return React.createElement("div", {
    className: "racing-pix-bet-summary-holder pix-dialog-holder"
  }, React.createElement("div", {
    className: "pix-bet-summary-header"
  }, Boolean(isHighFive) && React.createElement(HighFiveLogo, null), !isHighFive && productName), React.createElement("div", {
    className: "pix-bet-summary-sub-header"
  }, date, "\xA0", "".concat(time, ", "), "".concat(trackName, ", Lopp ").concat(raceNumber)), React.createElement("div", {
    className: "race-name"
  }, raceName), React.createElement("div", {
    className: "pix-bet-summary-list"
  }, mappedRacingSigns));
};
TableOfRaceDetails.defaultProps = defaultProps;
setGlobal('svs.components.sport.quickplayModal.TableOfRaceDetails', TableOfRaceDetails);

 })(window);